import script from "./RegisterStepbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterStepbar.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterStepbar.vue?vue&type=style&index=0&id=4ad575e6&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ad575e6"]])

export default __exports__